import React from 'react';
import { useDispatch } from 'react-redux';
import classNames from 'classnames';

import { TYPES } from 'store/modules/app/actions';
import { Button } from '../Button/Button';

interface Props {
  primaryLabel?: string;
  secondaryLabel?: string;

  onPrimary: () => void;
  onSecondary?: () => void;

  showCallback?: boolean;
}

export const FlowButtonBar = (props: Props) => {
  const {
    primaryLabel = 'Next',
    secondaryLabel = 'Back',
    onPrimary,
    onSecondary,
    showCallback = true,
  } = props;

  const dispatch = useDispatch();

  const showSecondary = onSecondary && secondaryLabel;

  return (
    <div className={classNames('FlowButtonBar', { noSecondary: !showSecondary })}>
      {/* Secondary button */}
      {showSecondary && (
        <Button
          label={secondaryLabel}
          onClick={onSecondary}
          className="Button Button--secondary FlowButtonBar-secondary"
        />
      )}

      {/* Primary button */}
      <Button
        label={primaryLabel}
        onClick={onPrimary}
        className="Button Button--primary FlowButtonBar-primary"
      />

      {/* Request callback */}
      {showCallback && (
        <Button
          label="Request callback"
          onClick={() => dispatch({ type: TYPES.SHOW_MODAL })}
          className="Button FlowButtonBar-callback"
        />
      )}
    </div>
  );
};
